// This is the config file for all ant attributes.
// Make sure to update popups setup where needed, like for '{ants.worker.creationCalories} calories'

export const ants: AntsSetup = {
    buffs: {
        attack: 0.05,
        carry: 0.5,
        defense: 0.05,
        speed: 0.5,
    },
    explorer: {
        creationCalories: 5,
        movingSpeed: 4,
        mutations: {
            defense: {
                buff: 'defense',
                movingSpeed: 2,
                wanderDistance: 5,
            },
            carrier: {
                buff: 'carry',
                movingSpeed: 2,
                wanderDistance: 5,
            },
            gardening: {
                movingSpeed: 8,
                revealDistance: 5,
                wanderDistance: 20,
            },
            speed: {
                buff: 'speed',
                movingSpeed: 5,
                revealDistance: 5,
                wanderDistance: 20,
            },
            useless: {
                movingSpeed: 0.75,
                wanderDistance: 5,
            },
            weapon: {
                buff: 'attack',
                movingSpeed: 4,
                wanderDistance: 20,
            },
        },
        revealDistance: 3,
        size: 0.8,
        turnCalories: 1,
        wanderDistance: 15,
    },
    queen: {
        movingSpeed: 2,
        revealDistance: 3,
        size: 3,
    },
    warrior: {
        creationCalories: 20,
        killChance: 0.25,
        movingSpeed: 3,
        revealDistance: 2,
        searchDistance: 3,
        size: 1.2,
        turnCalories: 1,
        wanderDistance: 1,
    },
    worker: {
        carryCapacity: 20,
        creationCalories: 10,
        movingSpeed: 2,
        searchDistance: 4,
        retargetChance: 0.75,
        revealDistance: 2,
        turnCalories: 1,
        wanderDistance: 1,
    },
};
